{getIdsAsList, get_from_list, partitionAndSort} = require('../../utils')

module.exports = {
  workflow: ($stateParams, workflows) ->
    return get_from_list(workflows, $stateParams.workflowId)

  workflowSteps: ($stateParams, allWorkflowSteps) ->
    steps = partitionAndSort(allWorkflowSteps, 'workflow', 'id')
    return steps[$stateParams.workflowId]

  entity: (Api, workflow) ->
    return Api.Entity.get({id: workflow.entity}).$promise
}
